import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Segment } from 'typings/segments'

export type SegmentVisibility = Record<Segment, boolean>

const initialState: SegmentVisibility = {
  58285: true,
  58280: true,
  58286: true,
  58283: true,
  58282: true,
  58284: true,
  58281: true,
}

const segmentVisibility = createSlice({
  name: 'selectAudienceProfilerKPI',
  initialState,
  reducers: {
    loadSegmentVisibility(_state, { payload }: PayloadAction<SegmentVisibility>) {
      return payload
    },
    setSegmentVisibility(
      state,
      { payload: { segment, visible } }: PayloadAction<{ segment: Segment; visible: boolean }>
    ) {
      state[segment] = visible
      return state
    },
  },
})

export const { loadSegmentVisibility, setSegmentVisibility } = segmentVisibility.actions

export default segmentVisibility.reducer
